import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal, Overline } from "./Reveal";
import { MEANINGS } from "@/lib/content";

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  return (
    <section id="about" ref={ref} className="py-24 sm:py-36">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <Reveal className="relative aspect-[4/5] overflow-hidden rounded-[32px]">
            <motion.img src="/img/altar.webp" alt="Candlelit ritual altar by Diana" style={{ y, scale: 1.15 }} className="w-full h-full object-cover" data-testid="about-image" />
          </Reveal>
        </div>
        <div className="lg:col-span-7 lg:pl-10 flex flex-col justify-center">
          <Reveal><Overline>The story of a name</Overline></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#2D2A26]">
              Received in the waters of <em className="text-[#A8613C]">Ashbridges Bay</em>, Toronto.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 text-base md:text-lg text-[#5E584F] leading-relaxed max-w-2xl">
              The name Shaya came to our founder, Diana, intuitively — during a spiritual experience while swimming. Only later was its meaning revealed. Shaya is rooted in the belief that every person is an expression of the Divine, and therefore inherently worthy, deserving and gifted — and that our path is to draw closer and closer to the God within.
            </p>
          </Reveal>
          <div className="mt-14 grid sm:grid-cols-3 gap-8 border-t border-[#E6E0D4] pt-10">
            {MEANINGS.map((m, i) => (
              <Reveal key={m.lang} delay={0.1 * i} className="group" >
                <p className="text-xs uppercase tracking-[0.25em] text-[#6E685F]">{m.lang}</p>
                <p className="font-display text-4xl mt-2 text-[#2D2A26] transition-colors duration-500 group-hover:text-[#A8613C]">{m.word}</p>
                <p className="mt-3 text-sm text-[#5E584F] leading-relaxed">{m.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
